export const riskProfile = [
  {
    code: "conservative",
    display_name: "Conservative",
  },
  {
    code: "risk-averse",
    display_name: "Risk Averse",
  },
  {
    code: "balance",
    display_name: "Balance",
  },
  {
    code: "growth",
    display_name: "Growth",
  },
  {
    code: "aggressive",
    display_name: "Aggressive",
  },
];
export const lifeStage = [
  {
    code: "single",
    display_name: "Single",
  },
  {
    code: "married",
    display_name: "Married",
  },
  {
    code: "married-with-young-children",
    display_name: "Married with Young Children",
  },
  {
    code: "married-with-older-children",
    display_name: "Married with Older Children",
  },
  {
    code: "near-retirement",
    display_name: "Near Retirement",
  },
  {
    code: "retirement",
    display_name: "Retirement",
  },
  {
    code: "others",
    display_name: "Others",
  },
];
export const financialAndFamilyGoal = [
  {
    code: "saving-and-investments",
    display_name: "Saving and Investments",
  },
  {
    code: "regular-income",
    display_name: "Regular Income",
  },
  {
    code: "retirement",
    display_name: "Retirement",
  },
  {
    code: "child",
    display_name: "Child",
  },
  {
    code: "protection",
    display_name: "Protection",
  },
];
const i = [
  "2.5",
  "3",
  "3.5",
  "4",
  "4.5",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "39",
  "40",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49",
  "50",
  "51",
  "52",
  "53",
  "54",
  "55",
  "56",
  "57",
  "58",
  "59",
  "60",
  "61",
  "62",
  "63",
  "64",
  "65",
  "66",
  "67",
  "68",
  "69",
  "70",
  "71",
  "72",
  "73",
  "74",
  "75",
  "76",
  "77",
  "78",
  "79",
  "80",
  "81",
  "82",
  "83",
  "84",
  "85",
  "86",
  "87",
  "88",
  "89",
  "90",
  "91",
  "92",
  "93",
  "94",
  "95",
  "96",
  "97",
  "98",
  "99",
  "100",
];
export const income = i.map(item => {
  return {
    code: (item * 100000).toString(),
    display_name: item + " Lakhs",
  };
});
